module.exports = __webpack_public_path__ + "media/4x3/cr-7b4ebd50.svg";